import React from 'react';
import get from 'lodash.get';
import { isContentfulString, resolveBackgroundColor } from '@philips-internal/oswald-ui-utils';
import { useCardContainer } from '../context/card-container-context.js';
function CardContainerSuperscription(props) {
    const context = useCardContainer();
    const { entry, items } = context.superscription;
    if (!Array.isArray(items) || items.length <= 0 || !isContentfulString(entry)) {
        return null;
    }
    const entryValue = get(props, entry);
    const item = items.find(item => item.value === entryValue);
    if (!item) {
        return null;
    }
    return (React.createElement("div", { className: "c-card-container__superscription", style: resolveBackgroundColor(item.color) }));
}
export { CardContainerSuperscription, };
//# sourceMappingURL=card-container-superscription.js.map